import HTTP from "@/_helpers/http";
import { PARTNERPAYMENTMETHOD__API } from "@/_helpers/urls";
import { PARTNERPAYMENTMETHOD__MUTATIONS } from "../mutation-types";
import { PARTNERPAYMENTMETHOD__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
    payment_methods: [],
};

// Getters
const getters = {};

// Mutations
const mutations = {
    [PARTNERPAYMENTMETHOD__MUTATIONS.PARTNER_PAYMENT_METHODS](state, data) {
        state.payment_methods = data;
    },
};

// Actions
const actions = {
    async [PARTNERPAYMENTMETHOD__ACTIONS.PARTNER_PAYMENT_METHODS]({ commit, state }) {
        try {
            const response = await HTTP().get(PARTNERPAYMENTMETHOD__API.PARTNER_PAYMENT_METHODS);

            if (response.status === 200) {
                commit(PARTNERPAYMENTMETHOD__MUTATIONS.PARTNER_PAYMENT_METHODS, response.data);
            }
        } catch (error) {
            console.log(error);
        }
    },

    async [PARTNERPAYMENTMETHOD__ACTIONS.CREATE_PARTNER_PAYMENT_METHOD]({ commit, dispatch }, data) {
        try {
            const response = await HTTP().post(PARTNERPAYMENTMETHOD__API.CREATE_PARTNER_PAYMENT_METHOD, data);

            if (response.status === 200) {
                await dispatch(PARTNERPAYMENTMETHOD__ACTIONS.PARTNER_PAYMENT_METHODS);
                toast.success(response.data.message || "Added successfully")
            }
        } catch (error) {
            console.log(error);
        }
    },

    async [PARTNERPAYMENTMETHOD__ACTIONS.EDIT_PARTNER_PAYMENT_METHOD]({ commit, dispatch }, data) {
        try {
            const response = await HTTP().put(`${PARTNERPAYMENTMETHOD__API.EDIT_PARTNER_PAYMENT_METHOD}/${data.id}`, data);

            if (response.status === 200) {
                await dispatch(PARTNERPAYMENTMETHOD__ACTIONS.PARTNER_PAYMENT_METHODS);
                toast.success(response.data.message || "Edited successfully")
            }
        } catch (error) {
            console.log(error);
        }
    },

    async [PARTNERPAYMENTMETHOD__ACTIONS.DELETE_PARTNER_PAYMENT_METHOD]({ commit, dispatch }, id) {
        try {
            const response = await HTTP().delete(`${PARTNERPAYMENTMETHOD__API.DELETE_PARTNER_PAYMENT_METHOD}/${id}`);

            if (response.status === 200) {
                await dispatch(PARTNERPAYMENTMETHOD__ACTIONS.PARTNER_PAYMENT_METHODS);
                toast.success(response.data.message || "Deleted successfully")
            }
        } catch (error) {
            console.log(error);
        }
    }
};

export default {
    namespaced: true,
    strict: process.env.NODE_ENV !== "production",
    state,
    getters,
    mutations,
    actions,
};
